import React from "react"
import IconSkeleton from "./IconSkeleton"
import { IconProps } from "./types"
import { useTheme } from "../ThemeProvider"

export default function ProfessionalPlanIcon(props: IconProps) {
  const theme = useTheme()

  return (
    <IconSkeleton {...props} iconName="ProfessionalPlanIcon" stroke="none">
      <path
        d="M4.65774 4.54746C4.97369 4.23151 5.4624 4.05164 6.15117 4.06176C6.84209 4.07191 7.69058 4.27476 8.6476 4.67453C10.5592 5.47307 12.8081 7.01711 14.9211 9.13008C17.034 11.243 18.5781 13.4919 19.3766 15.4036C19.7764 16.3606 19.9792 17.2091 19.9894 17.9C19.9995 18.5887 19.8196 19.0775 19.5037 19.3934C19.1877 19.7094 18.699 19.8892 18.0103 19.8791C17.3193 19.869 16.4708 19.6661 15.5138 19.2663C13.6022 18.4678 11.3533 16.9238 9.24036 14.8108C7.12739 12.6978 5.58335 10.449 4.78481 8.53732C4.38504 7.5803 4.18219 6.73181 4.17204 6.0409C4.16192 5.35212 4.34179 4.86341 4.65774 4.54746Z"
        stroke={theme.colors.blue[20]}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.3908 4.63159C19.7067 4.94754 19.8866 5.43625 19.8765 6.12502C19.8663 6.81594 19.6635 7.66443 19.2637 8.62144C18.4652 10.5331 16.9211 12.782 14.8082 14.8949C12.6952 17.0079 10.4463 18.5519 8.53469 19.3505C7.57768 19.7502 6.72919 19.9531 6.03827 19.9632C5.3495 19.9734 4.86079 19.7935 4.54484 19.4775C4.22889 19.1616 4.04901 18.6729 4.05914 17.9841C4.06929 17.2932 4.27214 16.4447 4.67191 15.4877C5.47044 13.576 7.01448 11.3272 9.12745 9.21421C11.2404 7.10124 13.4893 5.5572 15.4009 4.75866C16.3579 4.35889 17.2064 4.15604 17.8974 4.14589C18.5861 4.13577 19.0748 4.31564 19.3908 4.63159Z"
        stroke={theme.colors.blue[20]}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="12" cy="12" r="2" fill={theme.colors.blue[60]} />
      <circle cx="12" cy="7" r="1" fill={theme.colors.blue[60]} />
      <circle cx="12" cy="17" r="1" fill={theme.colors.blue[60]} />
    </IconSkeleton>
  )
}
